import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getItems,
  addIngredientsForProduct,
  getIngredientsForProduct,
} from "../../services/linkingIngredientsService";

const LinkingIngredientsModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const items = useSelector((state) => state.addIngredient);

  useEffect(() => {
    dispatch(getItems());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.suppliers.add_item")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.InventoryItemId = values.InventoryItemId?.InventoryItemId;
              values.ProductId = id.productId;
              values.UserId = localStorage.getItem("userId");

              if (values.InventoryItemId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
              dispatch(addIngredientsForProduct(values))
                .unwrap()
                .then((_) => {
                  toast({ description: "Ingredient created" });
                  dispatch(getIngredientsForProduct(id.productId));
                  onClose();
                });}
            })}
          >
            <Stack>
              <MultiSelect
                title={t("general.items")}
                data={
                  items.data &&
                  items.data.map((el) => ({
                    ...el,
                    label: el.InventoryItemNameEng,
                    value: el.InventoryItemId,
                  }))
                }
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("InventoryItemId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={items.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={items.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default LinkingIngredientsModal;
